

const template = document.createElement('template');
const generateNavigationMarkup = (amtSteps:number) => {
  const steps = [...new Array(amtSteps)].map((step, index) => {
    return `<button step-index="${index}" class="navigation-button"><span>${index + 1}</span></button>`;
  }).join('');

  return `
    <style>
      .bundle-navigation {
        max-width: 22.75rem;
        width: 100%;
        display: flex;
        gap: 0.625rem;
        margin-top: 4.8125rem;
        margin-bottom: 1.25rem;
      }

      .navigation-button {
        height: 2.25rem;
        width: 2.25rem;
        background-color: transparent;
        border-radius: 50%;
        border: 1px solid var(--transparent-seafoam-seafoam-40);
        color: var(--color-white);
        position: relative;
        transition: margin-right 0.5s, border-color 0.5s;
      }

      .navigation-button:last-child span {
        visibility: hidden;
      }

      .navigation-button:last-child::before {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 0.9375rem;
        height: 0.625rem;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 15 10'%3E%3Cg stroke='%23fff' stroke-linecap='square' clip-path='url(%23a)'%3E%3Cpath d='M0 1h15M0 5h15M0 9h8.824'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M0 0h15v10H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
      }

      .navigation-button::after {
        content: '';
        width: 0;
        height: 0.0625rem;
        background-color: var(--transparent-seafoam-seafoam-40);
        position: absolute;
        top: calc(50% - 0.0625rem);
        left: calc(100% + 0.375rem); 
        transition: width 0.5s;
      }

      .navigation-button.is-active {
        border-color: var(--color-white);
        margin-right: 10rem;
      }

      .navigation-button.is-active::after {
        width: 10rem;
      }

      .navigation-button:last-child.is-active {
        margin-left: 10rem;
        margin-right: 0;
      }

      .navigation-button:last-child.is-active::after {
        left: auto;
        right: calc(100% + 0.375rem);
      }

      @media screen and (max-width: 991px) {
        .bundle-navigation {
          margin-top: 1.25rem;
        }
      }
    </style>
    <div class="bundle-navigation" part="navigation">
      ${steps}
    </div>
  `;
} 
export class BundleNavigation extends HTMLElement {

  private readonly root:HTMLDivElement|null;
  private readonly amountSteps:number = parseInt(this.getAttribute('amount-steps') || '');

  private readonly navBtns:NodeListOf<HTMLButtonElement>|[] = [];

  constructor() {
    super();

    const template = document.createElement('template');
    template.innerHTML = generateNavigationMarkup(this.amountSteps)

    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.root = shadowRoot.querySelector('.bundle-navigation')!;
    this.navBtns = this.root.querySelectorAll('.navigation-button');

    this.navBtns.forEach(btn => {
      btn.addEventListener('click', this.handleNavBtnClick);
    });
  }

  public setActive(stepIndex:number) {
    this.navBtns.forEach((btn, index) => {
      btn.classList[stepIndex === index ? 'add' : 'remove']('is-active')
    })
  }

  private handleNavBtnClick() {
    const btn = this;
    const stepIndex = parseInt(btn.getAttribute('step-index') || '');

    const event = new CustomEvent('navigation', { 
      detail: { stepIndex }, 
      bubbles: true, 
      composed: true 
    });

    btn.dispatchEvent(event);
  }
}

if(!customElements.get('bundle-navigation')) {
  customElements.define('bundle-navigation', BundleNavigation);
}